import { fetchEventSource } from '@microsoft/fetch-event-source'
import { useKeycloak } from '~/stores/keycloak'

interface Count {
  count: number
}

export default defineNuxtPlugin(nuxtApp => {
  let isConnected = false
  let controller: AbortController | null = null
  const callbacks: ((count: number) => void)[] = []
  const config = useRuntimeConfig()
  const keycloakStore = useKeycloak()
  const url = `${config.public.notificationsAPI}/notifications/onEvent`
  const connectCalledOnce = ref(false)
  const notificationStore = useNotificationsStore()
  // Create a flag to prevent multiple connections
  const connectionInProgress = ref(false)

  keycloakStore.on('tokenRefresh', () => {
    if (connectCalledOnce.value) {
      connect()
    }
  })

  const disconnect = () => {
    if (controller) {
      controller.abort()
      controller = null
      isConnected = false
    }
  }

  const connect = async () => {
    console.log(connectionInProgress.value)
    // Skip connection if one is already in progress
    if (connectionInProgress.value) {
      console.log('SSE connection already in progress, skipping')
      return
    }

    connectCalledOnce.value = true
    connectionInProgress.value = true

    if (isConnected) {
      console.log('SSE already connected, disconnecting first')
      disconnect()
    }

    controller = new AbortController()
    isConnected = true

    try {
      const token = keycloakStore.keycloak?.token
      console.log('fetchEventSource')
      fetchEventSource(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json, text/plain, */*',
        },
        signal: controller.signal,
        openWhenHidden: true,
        onmessage(event) {
          try {
            const data: any = JSON.parse(event.data)
            if ('count' in data) {
              notificationStore.setCount(data.count)
            }
            if ('id' in data) {
              notificationStore.setNewNotification(data)
            }
          } catch (error) {
            console.error('Error parsing SSE data:', error)
          }
        },
        async onopen(response) {
          if (!response.ok) {
            disconnect()
          }
        },
        onerror(error) {
          console.error('SSE connection error:', error)
          disconnect()
          // Reset the flag to allow reconnection attempts
          connectionInProgress.value = false
        },
      })
    } catch (error) {
      console.error('Failed to establish SSE connection:', error)
      disconnect()
    } finally {
      // Always reset the flag when the connection attempt is complete
      console.log('connectionInProgress', connectionInProgress.value)
      connectionInProgress.value = false
    }
  }

  nuxtApp.provide('notifications', {
    connect,
    disconnect,
  })
})
